export function tooltipElementId(chartId: string): string {
  return `chartjs-tooltip-${chartId.replace(/[^a-zA-Z0-9_-]/g, '_')}`;
}

export function hideChartTooltip(chartId: string): void {
  if (typeof document === 'undefined') {
    return;
  }

  const tooltipEl = document.getElementById(tooltipElementId(chartId));
  if (!tooltipEl) {
    return;
  }

  tooltipEl.style.opacity = '0';
  tooltipEl.setAttribute('aria-hidden', 'true');
  tooltipEl.innerHTML = '';
}

export function removeChartTooltip(chartId: string): void {
  if (typeof document === 'undefined') {
    return;
  }

  document.getElementById(tooltipElementId(chartId))?.remove();
}
